import { useTranslation } from 'react-i18next'

import { TrashIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Alert, Chip, IconButton, Text } from '@reveni-io/reveni-ui'

import CriteriaEditor from '@/common/components/ConditionsEditor/CriteriaEditor/CriteriaEditor'
import { resolveConditionTypeConfig, supportsMultipleCriteria } from '@/common/components/ConditionsEditor/helpers'
import DescriptionBox from '@/common/components/DescriptionBox/DescriptionBox'

import AppliesWhenSelector from './AppliesWhenSelector/AppliesWhenSelector'
import * as Styles from './styles'

const ConditionCard = ({
  condition,
  index,
  onChange,
  onRemove,
  disabled,
  errorCriteriaIndexes = [],
  conditionTypes,
  currencies,
  storeCurrencyCode,
}) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const { config: conditionTypeConfig } = resolveConditionTypeConfig(conditionTypes, condition)
  const TypeIcon = conditionTypeConfig?.icon
  const description = conditionTypeConfig?.description
  const criteriaCount = condition.criteria.length
  const hasMultipleCriteria = criteriaCount > 1

  const handleChangeCriteria = criteria => onChange(index, { ...condition, criteria })

  const handleChangeAppliesWhen = value => onChange(index, { ...condition, applies_when: value })

  const handleRemove = () => onRemove(index)

  return (
    <Styles.Container>
      <Styles.Header>
        <Styles.ConditionType>
          {TypeIcon && <TypeIcon size={24} />}
          <Text type="bodyMBold">{t(conditionTypeConfig?.label)}</Text>
          {hasMultipleCriteria && (
            <Chip
              label={t('{{count}} propiedades', { count: criteriaCount })}
              backgroundColor={theme.colors.background.secondary}
            />
          )}
        </Styles.ConditionType>
        {!disabled && <IconButton variant="text" icon={<TrashIcon size={24} />} onClick={handleRemove} />}
      </Styles.Header>
      {description && (
        <DescriptionBox>
          <Text type="bodyMRegular" color={theme.colors.text.muted}>
            {t(description)}
          </Text>
        </DescriptionBox>
      )}
      <Styles.Fields>
        {conditionTypeConfig?.supportsAppliesWhen && (
          <AppliesWhenSelector
            value={condition.applies_when}
            onChange={handleChangeAppliesWhen}
            disabled={disabled}
            menuItems={conditionTypeConfig.appliesWhenMenuItems}
          />
        )}
        {hasMultipleCriteria && (
          <Alert type="info">{t('Todas las propiedades de este bloque deben coincidir en el mismo producto')}</Alert>
        )}
        <CriteriaEditor
          criteria={condition.criteria}
          properties={conditionTypeConfig?.properties}
          onChange={handleChangeCriteria}
          disabled={disabled}
          errorCriteriaIndexes={errorCriteriaIndexes}
          canAddCriteria={supportsMultipleCriteria(condition)}
          currencies={currencies}
          storeCurrencyCode={storeCurrencyCode}
        />
      </Styles.Fields>
    </Styles.Container>
  )
}

export default ConditionCard
